import {
  FontSelectDTO,
  RasterDTO,
  RasterFontDTO,
  RasterFontRealTimePreviewRequest,
} from '@/model';
import { apiGenericDelete, apiGenericGet, apiGenericPost } from '@/service';
import { getApiUrl, getApiUrlWithParams } from '@/util';
import { DeleteResponse, GenericPostResponse, SaveResponse } from '@/type';

const BASE_URL = '/api/v1/raster-font/';

export const listRasterFontsAPI = (): Promise<RasterFontDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'list'));

export const listRasterFontsByTTFIdAPI = (ttFontId: number): Promise<RasterFontDTO[]> =>
  apiGenericGet(getApiUrlWithParams(BASE_URL, 'listByTtFont', { ttFontId }));

export const listRasterFontsForSelectAPI = (): Promise<FontSelectDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'listFonts'));

export const saveRasterFontAPI = (request: RasterFontDTO): SaveResponse =>
  apiGenericPost(getApiUrl(BASE_URL, 'save'), request);

export const loadRasterFontAPI = (id: number): Promise<RasterFontDTO> =>
  apiGenericGet(getApiUrl(BASE_URL, `load/${id}`));

export const deleteRasterFontAPI = (id: number): DeleteResponse =>
  apiGenericDelete(getApiUrl(BASE_URL, `remove`), 'id', id);

export const loadRealTimePreviewRasterFontAPI = (
  request: RasterFontRealTimePreviewRequest,
): Promise<GenericPostResponse<RasterDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadRealTimePreview'), request, true);
